module.exports = __webpack_public_path__ + "bn.384df9d992676edd14cd.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/bn.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/bn.svg
// module chunks = styles